import React from 'react';
import i18next from 'i18next';
import { Card, CardBody, CardHeader, Button, Collapse } from 'reactstrap';
import NoData from '../shared/noData';
import Currency from './../shared/currency';
import UtilsService from './../../services/utils/utils.service';
import CancellationsPagination from './cancellationsPagination';
import { BalanceTotal } from '../holdings/balanceTotal';


export default class CancellationsTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            openedIndex: null,
            openedRowIndex: []
        };
    }

    componentDidMount() {}

    toggleCollapse = (index1) => {
        const index = `${index1}`;

        this.setState({
            openedIndex: (this.state.openedIndex != index) ? index : null
        });
    }

    isCollapseOpen(index1) {
        const index = `${index1}`;
        return this.state.openedIndex == index;
    }

    onRowClickOpen(index1, i) {
        const index = `${index1}${i}`;

        let openedRowIndex = this.state.openedRowIndex;
        const k = openedRowIndex.indexOf(index);
        if (k < 0) {
            openedRowIndex.push(index);
        } else {
            openedRowIndex.splice(k, 1);
        }

        this.setState({
            openedRowIndex: openedRowIndex
        })
    }

    isRowOpened(index1, i) {
        const index = `${index1}${i}`;
        return this.state.openedRowIndex.indexOf(index) >= 0;
    }

    isVisible = (s) => {
        return (s && s.length == 1) ?
            { color: '#e8f3f8' } :
            null;
    }

    render() {
        if ( !this.props.h ) return null;
        
        return (
            <Card className="ml-2 mb-3 position-relative" key={this.props.index}>
                <CardHeader
                    className="cursor-pointer"
                    onClick={() => this.toggleCollapse(this.props.index)}
                >
                    <div className="d-flex align-items-center">
                        <div className='flex-grow-1'>
                            <div className="lh-1 text-muted font-size-11 font-italic">
                                <span className="mr-1">{i18next.t('ACCOUNT')}: </span>
                                <strong>{this.props.h.accountCode} - {this.props.h.account}</strong>
                            </div>
                            <div className="lh-1 text-muted font-size-11 font-italic">
                                <span className="mr-1">{i18next.t('AGENT')}: </span>
                                <strong>{this.props.h.clearingMember}</strong>
                            </div>
                        </div>
                        <div className="text-right">
                            <BalanceTotal
                                totals={this.props.totals}
                                tag={'strong'}
                            />
                            <Button className="m-0" color="link" size="sm">
                                <i className={`fa fa-chevron-${this.isCollapseOpen(this.props.index) ? 'up' : 'down'}`}></i>
                            </Button>
                        </div>
                    </div>
                </CardHeader>
                <Collapse isOpen={this.isCollapseOpen(this.props.index)}>
                    <CardBody className="p-2">
                        <div className="table-responsive">
                            <table className="table table-sm mb-0 table-instruments">
                                <thead>
                                    <tr className="text-muted">
                                        <th style={{ width: '150px' }}>{i18next.t('DATE')}</th>
                                        <th style={{ width: '150px' }}>{i18next.t('INSTRUMENT')}</th>
                                        <th>{i18next.t('TYPE')}</th>
                                        <th className="text-right">{i18next.t('QUANTITY')}</th>
                                        <th className="text-right">{i18next.t('UNIT')}</th>
                                        <th className="text-right">{i18next.t('BUY_PRICE')}</th>
                                        <th className="text-right">{i18next.t('SELL_PRICE')}</th>
                                        <th className="text-right">{i18next.t('RESULT')}</th>
                                        <th className="text-right">{i18next.t('CURRENCY_SYMBOL')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.items.map((d, i) =>
                                        <React.Fragment key={`${this.props.index}-${i}`}>
                                            <tr 
                                                onClick={() => this.onRowClickOpen(this.props.index, `${this.props.index}-${i}`)}
                                                className={`${this.isRowOpened(this.props.index, `${this.props.index}-${i}`) ? 'active' : null} row-hover`}
                                            >
                                                <td>{UtilsService.dateFormat(d.clearingBusinessDate, 'dd/MM/yyyy')}</td>
                                                <td>{d.instrument.symbol || '-'}</td>
                                                <td>{d.instrument.securityType || '-'}</td>
                                                <td className="text-right">
                                                    <Currency amount={d.tradeVariationAmount} symbol={false} />
                                                </td>
                                                <td className="text-right">
                                                    {d.instrument.unitOfMeasure ? UtilsService.translateUnitOfMeasurement(d.instrument.unitOfMeasure) : '-'}
                                                </td>
                                                <td className="text-right">
                                                    <Currency amount={d.buyPrice} symbol={false} />
                                                </td>
                                                <td className="text-right">
                                                    <Currency amount={d.sellPrice} symbol={false} />
                                                </td>
                                                <td className="text-right">
                                                    <Currency amount={d.positionAmountData} symbol={false} />
                                                </td>
                                                <td className="text-right">
                                                    {UtilsService.translateCurrencySymbol(d.currency)}
                                                </td>
                                            </tr>
                                            {this.isRowOpened(this.props.index,  `${this.props.index}-${i}`) ?
                                                
                                                <tr className="row-details font-size-11" key={`${this.props.index}-${i}-0`}>
                                                    <td>
                                                        <div>
                                                            <strong>{i18next.t('BUY_DATE')}: </strong>
                                                            <span>{UtilsService.dateFormat(d.buyDate, 'dd/MM/yyyy') || '-'}</span>
                                                        </div>
                                                        <div>
                                                            <strong>{i18next.t('SELL_DATE')}: </strong>
                                                            <span >{UtilsService.dateFormat(d.sellDate, 'dd/MM/yyyy') || '-'}</span>
                                                        </div> 
                                                    </td> 
                                                    <td className="text-right" colSpan={8}></td>
                                                </tr>
                                                :
                                                null
                                            }
                                        </React.Fragment>
                                    )}

                                    {!this.props.items.length && !this.state.isLoading ?
                                        <tr>
                                            <td colSpan="99">
                                                <NoData className="pt-2" msg={i18next.t('NO_RESULTS')} />
                                            </td>
                                        </tr> :
                                        null
                                    }
                                </tbody>
                            </table>
                            <CancellationsPagination
                                page={this.props.page}
                                total={this.props.h.registersNumber}
                                onChange={(pageNumber) => this.props.onChange(pageNumber)} />
                        </div>
                    </CardBody>
                </Collapse>
            </Card>
        );
    }
}